import { matchPath, useLocation } from 'react-router-dom';

import { NETCHEX_MOBILE_SUPPORTED_PATHS } from 'constants/netChexConstants';

export const useIsNetchexMobileSupportedPage = () => {
  const location = useLocation();
  const { search: addressBarSearch = '' } = location;

  const addressBarURLParams = new URLSearchParams(addressBarSearch);

  const matchingIndex = NETCHEX_MOBILE_SUPPORTED_PATHS.findIndex((route) => {
    const [routePathname, routePathQueryParams] = route.split('?');

    const pathURLParams = new URLSearchParams(routePathQueryParams);
    // check if pathURLParams matches addressBarURLParams, there could be additional params in addressBarURLParams, which we don't care about
    const isQueryParamsMatch = [...pathURLParams.entries()].every(([key, value]) => {
      const addressBarValue = addressBarURLParams.get(key);
      return addressBarValue === value;
    });

    const match = matchPath(location.pathname, {
      path: routePathname,
      exact: true,
    });

    // if (!!match && isQueryParamsMatch) {
    //   console.log('################  Is netchex mobile supported page', route, match);
    // }
    return !!match && isQueryParamsMatch;
  });
  // if (matchingIndex === -1) {
  //   console.log('###--------------------- NOT Is netchex mobile supported page', location.pathname);
  // }
  return matchingIndex !== -1;
};
